import React, { useEffect, useState } from "react";
import { ApiService } from "../../components/Common/ApiService";
import { isIdTarget } from "../../store/actions/todoActions";

import { useDispatch } from "react-redux";
import Button from "../../components/Common/Button";
import { ReactComponent as SearchIcon } from "../../assets/icon/ri_search-line.svg";

import ConditionalRender from "../../components/Common/ConditionalRender";
import Input from "../../components/Common/Input";
import { formatRupiah } from "../../components/Common/utils";

function DaftarLayanan() {
    const [daftarProdukData, setDaftarProdukData] = useState([]);
    const [categoryData, setCategoryData] = useState([]);
    const [setJenisData] = useState([]);

    const [daftarProdukloading, setDaftarProdukLoading] = useState(true);
    const [jenis] = useState("Semua");
    const [category, setCategory] = useState("Semua");
    const [kodeproduk, setKodeProduk] = useState("");

    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(isIdTarget(undefined));
        fetchDaftarProduk();
        fetchJenis()
    }, [jenis, category]);
    const fetchDaftarProduk = async () => {
        setDaftarProdukLoading(true);
        try {
            const response = await ApiService({
                baseurl: `user/daftarProduk${kodeproduk === "" ? "" : `?search=${kodeproduk}`
                    }${jenis === "Semua" ? "" : `${kodeproduk === "" ? "?" : "&"}jenis=${jenis.toLowerCase()}`}${category === "Semua" ? "" : `${(kodeproduk === "" && jenis === "Semua") ? "?" : "&"}kategori=${category.toLowerCase()}`}`,

                method: "GET",
                XGORDON: "DAFTARPRODUK",
            });
            setDaftarProdukLoading(false);
            if (response?.statusCode === 200) {
                setDaftarProdukData(response.result.data.produk);

                const data = response.result.data.produk;
                const updatedata = [...data]
                const resultArray = updatedata.map(item => ({ text: item.kategori, value: item.kategori }));
                const uniqueArray = [...new Set(resultArray.map(JSON.stringify))].map(JSON.parse);
                uniqueArray.unshift({ text: 'Pilih Produk', value: 'Semua' });

                setCategoryData(uniqueArray);
            } else {
                setDaftarProdukData([]);
            }
        } catch (error) {
            console.error("Error fetching data:", error);
        }
    };

    const fetchJenis = async () => {
        try {
            const response = await ApiService({
                baseurl: "user/kategori",
                method: "GET",
                XGORDON: "KATEGORI",
            });
            if (response?.statusCode === 200) {
                const data = response.result.data;
                const updatedata = [...data]
                const resultArray = updatedata.map(item => ({ text: item.jenis, value: item.jenis }));
                const uniqueArray = [...new Set(resultArray.map(JSON.stringify))].map(JSON.parse);
                uniqueArray.unshift({ text: 'Pilih Jenis', value: 'Semua' });

                setJenisData(uniqueArray);

            } else {
                setJenisData([]);
            }
        } catch (error) {
            console.error("Error fetching data:", error);
        }
    };


    return (
        <div className="flex flex-col gap-3 flex-1 relative ">
            <div className="flex flex-row lg:rounded-lg rounded-none shadow-inner overflow-hidden bg-cardLight dark:bg-cardDark sm: min-h-[100px] relative">
                <div className="flex flex-col gap-2 justify-center flex-1 p-3">
                    <span className="text-3xl  text-[#22BDE2] font-bold"> Daftar Layanan</span>
                    <span className=" text-base font-light ">
                        Ini adalah halaman untuk melihat daftar harga semua produk kami.
                        Silahkan pilih produk untuk melihat list harga
                    </span>
                </div>
                <div className="md:flex hidden flex-1">
                    <img
                        src={require('../../assets/images/pngwing 2.png')}
                        alt="Logo"
                        className="object-cover  object-right flex-1 h-40 " />
                </div>
            </div>

            <div
                className="flex flex-row lg:rounded-lg rounded-none shadow-inner p-4  overflow-hidden bg-cardLight dark:bg-cardDark relative"
            >
                <div className="flex flex-col gap-2 justify-end w-full ">
                    <div className="flex sm:flex-row flex-col gap-2 flex-1 justify-between items-end w-full">
                        <div className="flex flex-row gap-2 items-center sm:max-w-[230px] bg-[#ffffff]  p-2.5 w-full flex-1 rounded-lg border-1 h-11 ">
                            <select
                                value={category}
                                onChange={(event) => {
                                    const inputValue = event.target.value;
                                    if (inputValue.length <= 200) {
                                        setCategory(inputValue);
                                    }
                                }}
                                className={`text-md cursor-pointer bg-transparent focus:outline-none focus:ring-0 w-full h-8 text-lightColor `}
                            >
                                {categoryData.map((option) => (
                                    <option key={option.value} value={option.value}>
                                        {option.text}
                                    </option>
                                ))}
                            </select>
                        </div>
                        <div className="flex sm:flex-row flex-col gap-2 items-end sm:w-96 w-full">
                            <div className="flex flex-1 w-full ">
                                <Input
                                    id={1}
                                    value={kodeproduk}
                                    onChange={(value) => {
                                        const inputValue = value;
                                        setKodeProduk(inputValue);
                                    }}
                                    type={"text"}
                                    className={'h-11'}
                                    bgcolor={"bg-[#edeeee]"}
                                    placeholder={`Ketikan kode produk`}
                                />
                            </div>
                            <Button
                                iconLeft={<SearchIcon className="h-5 w-5" />}
                                type="fill"
                                color={'#ffffff'}
                                className={"bg-[#22BDE2] text-darkColor h-10"}
                                onClick={() => {
                                    fetchDaftarProduk();
                                }}
                            />
                        </div>
                    </div>
                </div>
            </div>

            <div className="flex flex-col lg:rounded-lg rounded-none  shadow-inner bg-cardLight dark:bg-cardDark overflow-hidden relative">
                <div className=" pb-3 min-h-[620px]  relative">
                    <div className="overflow-x-scroll no-scrollbar  absolute z-10 top-0 left-0 right-0 bottom-0">
                        <ConditionalRender
                            productsData={daftarProdukData}
                            isLoading={daftarProdukloading}
                            model={"emptyData"}
                        >
                            <table className="min-w-full text-left text-sm font-light table-auto ">
                                <thead className="border-b  font-medium bg-gradient-to-r from-[#22BDE2] to-[#FC00FF] text-darkColor">
                                    <tr>
                                        <th scope="col" className=" p-3">PID</th>
                                        <th scope="col" className=" p-3">KATEGORI</th>
                                        <th scope="col" className=" p-3">LAYANAN</th>
                                        <th scope="col" className=" p-3">HARGA</th>
                                        <th scope="col" className=" p-3">HARGA SILVER</th>
                                        {/* <th scope="col" className=" p-3">HARGA GOLD</th> */}
                                        <th scope="col" className=" p-3">HARGA PRO</th>
                                        <th scope="col" className=" p-3">STATUS</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {daftarProdukData[0]?.items.map((item, index) => (
                                        <tr key={index}
                                            className={`border-b border-[#ffffff2d] ${index % 2 === 0 ? 'bg-[#DFF9FF] dark:bg-[#ffffff13]' : ''
                                                }`}>
                                            <td className="whitespace-nowrap  p-3 font-medium ">{item.id}</td>
                                            <td className="whitespace-nowrap  p-3"> {item.kategori}</td>
                                            <td className="whitespace-nowrap p-3">
                                                {item.layanan}
                                            </td>
                                            <td className="whitespace-nowrap  p-3"> {formatRupiah(item.harga)}</td>
                                            <td className="whitespace-nowrap  p-3"> {formatRupiah(item.harga_silver)}</td>
                                            {/* <td className="whitespace-nowrap  p-3"> {formatRupiah(item.harga_gold)}</td> */}
                                            <td className="whitespace-nowrap  p-3"> {formatRupiah(item.harga_pro)}</td>
                                            <td className="whitespace-nowrap flex-col p-2">
                                                <div className="flex flex-row">
                                                    <div className={`${item.status === "Aktif"
                                                        ? "bg-[#0ABE5D]"
                                                        : "bg-[#F42536]"
                                                        } rounded-tr-lg rounded-bl-lg `}>
                                                        <span className="text-[#ffffff] text-xs font-medium line-clamp-1 m-2 my-1">
                                                            {item.status}
                                                        </span>
                                                    </div>
                                                </div>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </ConditionalRender>
                    </div>
                </div>
            </div>


        </div>
    );
}

export default DaftarLayanan;
